// Native & external imports
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// Objects
import { CmpFauxDropDownObject, CmpFauxDropDownOptionsObject } from 'src/objects/cmp-faux-dropdown.object';

@Component({
  standalone: false,
  selector: 'cmp-faux-select-dropdown',
  templateUrl: './faux-select-dropdown.component.html'
})
export class FauxSelectDropdownComponent implements OnInit {

  public fauxOption: CmpFauxDropDownObject = new CmpFauxDropDownObject;
  @Input() set optionDetails(value: CmpFauxDropDownObject) {
    this.fauxOption = value;
    this.fsdOpen = false;
  }
  // @Input() optionDetails: CmpFauxDropDownObject = new CmpFauxDropDownObject();
  @Output() getSelection = new EventEmitter();

  public elementId = '';
  public fsdOpen = false;
  public selectedValue: string | number = '';
  constructor() { }

  ngOnInit() {
    this.elementId = `${this.fauxOption.label.name}-${new Date()}`;
  }

  public fauxDropDownSelected(option: CmpFauxDropDownOptionsObject) {
    this.getSelection.emit({
      option
    });
  }

  public selectOption(option: CmpFauxDropDownOptionsObject) {
    this.fsdOpen = false;
    this.fauxOption.label.selectedLabel = option.name;
    if (!option.status) {
      this.selectedValue = option.value;
    }
    this.fauxDropDownSelected(option);
  }

}
